<template>
    <div class="mb-4 text-left">
        <div class="form-group mb-2">
            <textarea class="form-control" v-model="new_announcement" type="text" maxlength="600" placeholder="New announcement" aria-label="announcement"  v-on:keyup.enter="announce"/>
        </div>
        <button @click="announce" :disabled="is_disabled" class="btn btn-sm btn-secondary text-left" type="button" id="btn-addon">Submit</button>
    </div>
</template>

<script>
import Firebase from 'firebase/app'
import { db } from '@/main.js'

export default {
    name: "AnnounceForm",
    components: {

    },
    data () {
        return {
            new_announcement: "",
            is_disabled: false
        }
    },
    methods: {
        announce: function () {
            this.is_disabled = true
            if (this.new_announcement.length > 0) {
                db.collection('announcements').add({
                    text: this.new_announcement,
                    user: {
                        uid: this.$root.sharedState.uid,
                        name: this.$root.sharedState.username
                    },
                    date: Firebase.firestore.Timestamp.fromDate(new Date(Date.now())),
                    org: this.$root.sharedState.org
                }).then(function(docRef) {
                    console.log("Successfully written.", docRef.id)
                }).catch(function(error) {
                    console.log("Error writing to db", error)
                })
                this.new_announcement= ""
            }
            this.is_disabled = false
        },
    }
}
</script>
